<router-outlet />
<ngx-sonner-toaster [visibleToasts]="6" closeButton />
@if (region | async) {}
